import { createContext } from 'react'

const ClientPortalTheme = createContext()

export default ClientPortalTheme
